import Box from "@mui/joy/Box"
import Typography from "@mui/joy/Typography";

export function Configuration() {
  return (
    <Box>
      <Typography level="h1" sx={{mt: "2rem"}}>Config Table</Typography>
      <Typography level="body-md">
        Lorem ipsum...
      </Typography>
    </Box>
  );
}
